// extracted by mini-css-extract-plugin
export default {"Row":"Location_Row__t4Et+","IconWrapper":"Location_IconWrapper__ihHes","Icon":"Location_Icon__aZNmM","IconView":"Location_IconView__XghNE","IconMap":"Location_IconMap__kr80Y"};